import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChargeRecords = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3 1H4.69999C4.19608 1 3.7128 1.20018 3.35648 1.5565C3.00017 1.91282 2.79999 2.39609 2.79999 2.9V18.1C2.79999 18.6039 3.00017 19.0872 3.35648 19.4435C3.7128 19.7998 4.19608 20 4.69999 20H16.1C16.6039 20 17.0872 19.7998 17.4435 19.4435C17.7998 19.0872 18 18.6039 18 18.1V6.7L12.3 1Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3 1V6.7H18",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3 4H8.69999C8.19608 4 7.7128 4.20018 7.35648 4.5565C7.00017 4.91282 6.79999 5.39609 6.79999 5.9V21.1C6.79999 21.6039 7.00017 22.0872 7.35648 22.4435C7.7128 22.7998 8.19608 23 8.69999 23H20.1C20.6039 23 21.0872 22.7998 21.4435 22.4435C21.7998 22.0872 22 21.6039 22 21.1V9.7L16.3 4Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3 4V9.7H22",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6556 9L11 14.4H14.2901L13.9245 18L17.5802 12.6H14.2901L14.6556 9Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChargeRecords);
export { ForwardRef as ReactComponent };
